// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1989":"58941fa4","5495":"e9c800e7"}[chunkId] + ".chunk.css";
};